import { PERSONA, PERSONAS, PERSONAS_ME } from '@mm/api-routes';
import { snake } from '../helpers/converterString';
import { PersonaModel } from '../model/PersonaModel';
import AuthenticatedController from './AuthenticatedController';

export class PersonasController extends AuthenticatedController {
  static retrieveAll(remotePageId: string): Promise<PersonaModel[]> {
    return super.get(PERSONAS, snake({ remotePageId }));
  }
  static retrieve(
    remotePageId: string,
    personaId: number,
  ): Promise<PersonaModel> {
    return super.get(PERSONA(personaId), snake({ remotePageId }));
  }

  static retrieveMe(remotePageId: string): Promise<PersonaModel> {
    return super.get(PERSONAS_ME, snake({ remotePageId }));
  }

  static updateMe(personaName: string, personaAssetId?: number): Promise<void> {
    return super.post(PERSONAS_ME, snake({ personaName, personaAssetId }));
  }
}
